export default __webpack_public_path__ + "static/media/social-media.7361ff04.png";